import { render, staticRenderFns } from "./SystemTagManagementSinglePagination.vue?vue&type=template&id=338e867f&scoped=true"
import script from "./SystemTagManagementSinglePagination.vue?vue&type=script&lang=js"
export * from "./SystemTagManagementSinglePagination.vue?vue&type=script&lang=js"
import style0 from "./SystemTagManagementSinglePagination.vue?vue&type=style&index=0&id=338e867f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338e867f",
  null
  
)

export default component.exports